import React, { useState } from "react";
import { IoDocumentTextOutline } from "react-icons/io5";
import { FaSort, FaSortUp, FaSortDown } from "react-icons/fa";
import { LuPencil } from "react-icons/lu";
import { IoBan } from "react-icons/io5";
import { GoTrash } from "react-icons/go";
import { MdClose } from "react-icons/md";
import HeaderFilter from "../../Dashboard/DashboardTable/HeaderFilter";
import Pagination from "./Pagination";
import { IoAdd } from "react-icons/io5";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import DeleteVec from "../../../../../Assets/Images/deleteVec.png";
import UnBlockVec from "../../../../../Assets/Images/unblockVec.png";
import { LiaUserLockSolid } from "react-icons/lia";

const userData = [
  {
    name: "Emily Rose",
    email: "emilyRose@toner.com",
    phone: "+91 987 654 3210",
    reportDate: "02 Jan, 2023",
    reportedBy: "John Doe",
    about: <IoDocumentTextOutline className="text-xl" />,
    avatar: "https://i.pravatar.cc/150?img=1",
  },
  {
    name: "Edward Davidson",
    email: "EdwardDavidson@toner.com",
    phone: "+1 987 654 3210",
    reportDate: "05 Jan, 2023",
    reportedBy: "Alice Smith",
    about: <IoDocumentTextOutline className="text-xl" />,
    avatar: "https://i.pravatar.cc/150?img=2",
  },
];

export default function ReportUsersList({
  isAddUserModalOpen,
  closeAddUserModal,
  openAddUserModal,
}) {
  const [sortConfig, setSortConfig] = useState({
    key: "name",
    direction: "asc",
  });
  const [isMenuOpen, setIsMenuOpen] = useState(null);

  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isBlockModalOpen, setIsBlockModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

  const [imagePreview, setImagePreview] = useState(null); // For image upload
  const [newUserDetails, setNewUserDetails] = useState({
    name: "",
    email: "",
    phone: "",
    country: "",
    gender: "",
    avatar: "",
  });

  const sortedData = [...userData].sort((a, b) => {
    if (a[sortConfig.key] < b[sortConfig.key])
      return sortConfig.direction === "asc" ? -1 : 1;
    if (a[sortConfig.key] > b[sortConfig.key])
      return sortConfig.direction === "asc" ? 1 : -1;
    return 0;
  });

  const handleSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });
  };

  const toggleMenu = (index) => {
    setIsMenuOpen(isMenuOpen === index ? null : index);
  };

  const openModal = (type) => {
    if (type === "edit") {
      setIsEditModalOpen(true);
    } else if (type === "block") {
      setIsBlockModalOpen(true);
    } else if (type === "delete") {
      setIsDeleteModalOpen(true);
    }
  };

  const closeModal = (type) => {
    if (type === "edit") {
      setIsEditModalOpen(false);
    } else if (type === "block") {
      setIsBlockModalOpen(false);
    } else if (type === "delete") {
      setIsDeleteModalOpen(false);
    }
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImagePreview(URL.createObjectURL(file));
    }
  };

  const handleRemoveImage = () => {
    setImagePreview(null);
  };

  const handleNextClick = () => {
    // Handle next step logic if needed
  };

  return (
    <section>
      <HeaderFilter />

      <div className="overflow-x-auto">
        <table className="min-w-full whitespace-nowrap border-0 rounded-md">
          <thead className="bg-[#F9F7FF] text-sm font-medium text-gray-700">
            <tr>
              {[
                { key: "name", label: "User Name" },
                { key: "email", label: "Email Address" },
                { key: "phone", label: "Phone Number" },
                { key: "reportDate", label: "Report Date" },
                { key: "reportedBy", label: "Reported By" },
                { key: "reason", label: "Reason" },
              ].map(({ key, label }) => (
                <th
                  key={key}
                  className="px-4 py-4 font-medium cursor-pointer select-none"
                  onClick={() => handleSort(key)}
                >
                  <div className="flex items-center gap-2">
                    {label}
                    {sortConfig.key === key ? (
                      sortConfig.direction === "asc" ? (
                        <FaSortUp />
                      ) : (
                        <FaSortDown />
                      )
                    ) : (
                      <FaSort className="text-gray-300" />
                    )}
                  </div>
                </th>
              ))}
              <th className="px-4 py-4 font-medium">Action</th>
            </tr>
          </thead>

          <tbody className="divide-y divide-gray-100 text-sm">
            {sortedData.map((user, index) => (
              <tr
                key={index}
                className={`bg-white hover:bg-gray-50 ${
                  index === 0 ? "border-t-0" : ""
                }`}
              >
                <td className="px-4 py-4">
                  <div className="flex items-center gap-3">
                    <img
                      src={user.avatar}
                      alt={user.name}
                      className="w-8 h-8 rounded-full object-cover"
                    />
                    <span>{user.name}</span>
                  </div>
                </td>
                <td className="px-4 py-4">{user.email}</td>
                <td className="px-4 py-4">{user.phone}</td>
                <td className="px-4 py-4">{user.reportDate}</td>
                <td className="px-4 py-4">
                  <div className="flex items-center gap-3">
                    <img
                      src={user.avatar}
                      alt={user.reportedBy}
                      className="w-8 h-8 rounded-full object-cover"
                    />
                    <span>{user.reportedBy}</span>
                  </div>
                </td>
                <td
                  className="px-4 py-4 max-w-[180px] cursor-pointer truncate"
                  title={user.reason}
                  onClick={() => toggleMenu(index)}
                >
                  {user.about}
                  {isMenuOpen === index && (
                    <div className="absolute left-2/3 max-w-lg border border-[#EBEBEB] bg-[#F9F7FF] shadow-lg p-2 rounded-md mt-2 w-1/2 z-50">
                      <div className="flex items-center justify-between rounded-md border-b">
                        <div className="text-gray-700 px-4 py-2 block">
                          Reason
                        </div>
                        <button className="text-gray-700 px-4 py-2 block">
                          <MdClose size={18} />
                        </button>
                      </div>
                      <div className="text-black whitespace-pre-wrap break-words font-semibold px-4 py-2">
                        Directing hate against a protected category (e.g., race,
                        religion, gender, orientation, disability)
                      </div>
                    </div>
                  )}
                </td>{" "}
                <td className="px-4 py-4 flex items-center gap-3 text-gray-600">
                  <button
                    title="Delete"
                    className="bg-[#FFEFEE] rounded-md h-[30px] w-[30px] flex items-center justify-center text-[#F44336] hover:opacity-50"
                    onClick={() => openModal("delete")}
                  >
                    <GoTrash />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <Pagination
        currentPage={2}
        totalItems={50}
        itemsPerPage={10}
        onPageChange={(page) => {
          console.log("Navigate to page:", page);
          // Handle your routing or state update here
        }}
      />
      {isDeleteModalOpen && (
        <div className="modal modal-open">
          <div className="modal-box relative bg-white">
            <div className="flex items-center justify-between">
              <h2 className="text-lg font-semibold">Delete User</h2>

              <MdClose onClick={() => closeModal("delete")} size={18} />
            </div>

            {/* Image */}
            <div className="flex justify-center mb-4">
              <img
                src={DeleteVec} // <-- replace with your actual path
                alt="Block warning"
              />
            </div>

            {/* Block confirmation content */}
            <p className="capitalize text-md mb-2 text-center font-bold text-xl">
              Are you sure to delete user?
            </p>
            <p className="text-sm text-gray-600 mb-8 text-center">
              Are you sure you want to remove this record ?
            </p>
            <div className="flex justify-center gap-10 mt-4">
              <button
                onClick={() => closeModal("delete")}
                className="btn btn-outline btn-sm border border-[#EBEBEB] min-w-30 rounded-full min-h-[40px] hover:opacity-50 hover:bg-white hover:shadow-none hover:text-black"
              >
                Cancel
              </button>
              <button
                onClick={() => closeModal("delete")}
                className="btn btn-error bg-[#F44336] btn-sm min-w-30 rounded-full shadow-none text-white p-2.5 min-h-[40px] hover:opacity-50"
              >
                Yes, Block It!
              </button>
            </div>
          </div>
        </div>
      )}

      {isAddUserModalOpen && (
        <div className="modal modal-open">
          <div className="modal-box max-w-3xl bg-white">
            <div className="flex justify-between items-center">
              <h2 className="text-xl font-semibold">Add User</h2>
              <MdClose
                className="cursor-pointer"
                onClick={closeAddUserModal}
                size={20}
              />
            </div>
            <form>
              {/* Profile Image Section */}
              <div className="profile-bg max-w-sm flex mx-auto">
                <div className="my-4 w-[130px] h-[130px] mx-auto rounded-4xl border border-dashed border-[#000] overflow-hidden relative">
                  <label
                    htmlFor="imageUpload"
                    className="bg-white cursor-pointer w-full h-full flex items-center justify-center"
                  >
                    {imagePreview ? (
                      <img
                        src={imagePreview}
                        alt="Profile Preview"
                        className="w-full h-full object-cover rounded-4xl"
                      />
                    ) : (
                      <IoAdd className="text-[#7104F8] text-4xl" />
                    )}
                  </label>

                  {imagePreview && (
                    <button
                      type="button"
                      onClick={handleRemoveImage}
                      className="absolute top-1 right-1 bg-[var(--primary-color)] rounded-full p-1 shadow"
                    >
                      <MdClose className="text-white text-xl" />
                    </button>
                  )}

                  <input
                    type="file"
                    id="imageUpload"
                    accept=".jpg,.png"
                    onChange={handleImageChange}
                    className="hidden"
                  />
                </div>
              </div>

              {/* Upload Info Section */}
              <div className="text-center pt-2">
                <p className="text-md text-gray-400 font-normal my-3 w-2/4 text-center flex mx-auto justify-center">
                  Upload a Photo of the User. Click the Submit Button to
                  Continue.
                </p>
              </div>

              {/* User Info Section */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mt-4">
                {/* User Name Field */}
                <div className="mb-0">
                  <label
                    htmlFor="userName"
                    className="block text-sm text-gray-700 pb-2"
                  >
                    User Name
                  </label>
                  <input
                    type="text"
                    id="userName"
                    className="w-full p-2.5 border border-[#EBEBEB] rounded-md"
                    placeholder="Enter Full Name"
                  />
                </div>

                {/* Phone Number Field */}
                <div className="mb-0">
                  <label
                    htmlFor="phoneNumber"
                    className="block text-sm text-gray-700 pb-2"
                  >
                    Phone Number
                  </label>
                  <div className="flex">
                    <PhoneInput
                      country={"us"}
                      // value={formik.values.phone}
                      // onChange={(phone) => formik.setFieldValue("phone", phone)}
                      containerClass="!w-full !border !rounded-md"
                      inputProps={{
                        placeholder: "Enter phone number",
                        name: "phone",
                        autoFocus: false,
                      }}
                      inputClass="!w-full !py-5.5 !pl-14 !pr-4 !rounded-lg !border-none !border-[#EBEBEB] !focus:ring-2 !focus:ring-purple-500 !focus:border-purple-500 !text-base"
                      buttonClass="!bg-transparent !border-none !outline-none !px-3"
                      dropdownClass="!z-50 border-left"
                      inputStyle={{ width: "100%" }}
                    />
                  </div>
                </div>

                {/* Email Field */}
                <div className="mb-0">
                  <label
                    htmlFor="email"
                    className="block text-sm text-gray-700 pb-2"
                  >
                    Email
                  </label>
                  <input
                    type="email"
                    id="email"
                    className="w-full p-2.5 border border-[#EBEBEB] rounded-md"
                    placeholder="Enter Email Address"
                  />
                </div>

                {/* Gender Field */}
                <div className="mb-0">
                  <label
                    htmlFor="gender"
                    className="block text-sm text-gray-700 pb-2"
                  >
                    Gender
                  </label>
                  <select
                    id="gender"
                    className="w-full p-2.5 border border-[#EBEBEB] rounded-md"
                  >
                    <option value="">Select gender</option>
                    <option value="Male">Male</option>
                    <option value="Female">Female</option>
                    <option value="Other">Other</option>
                  </select>
                </div>

                {/* About Field */}
                <div className="mb-4 md:col-span-2">
                  <label
                    htmlFor="about"
                    className="block text-sm text-gray-700 pb-2"
                  >
                    About
                  </label>
                  <select
                    id="about"
                    className="w-full p-2.5 border border-[#EBEBEB] rounded-md"
                  >
                    <option value="">Select</option>
                    <option value="working-remotely">Working Remotely</option>
                    <option value="unemployed">Unemployed</option>
                  </select>
                </div>
              </div>

              {/* Submit Button */}
              <div className="w-full text-sm flex justify-end gap-3 items-center mt-6">
                <button
                  type="button"
                  className="bg-transparent text-black border border-[#ebebe] py-2 px-6 rounded-full hover:opacity-50"
                  onClick={handleNextClick}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="bg-[#7104F8] text-white border border-[#7104F8] py-2 px-8 rounded-full hover:opacity-50"
                  onClick={handleNextClick}
                >
                  Next
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </section>
  );
}
